<form [formGroup]="productForm">
    
    <table style="margin-left:990px;margin-top: 10px;">
        <tr>
            <td></td>
          <td style="font-weight: 600;">Status</td>
          <td style="font-weight: 600;">Due Date</td>
      </tr>
        <tr>
          <td>       
              <button (click)="ClearDD()" style="margin-bottom: 20px;" mat-raised-button>Clear</button>
              </td>                  
    <td>
  <mat-form-field appearance="outline" style="width:150px">
      <mat-label>Select</mat-label>
      <mat-select   formControlName="Filter_Status" (selectionChange)="FilterFormArray()" name="Filter_Status">                
          <mat-option value="Complete">Complete</mat-option>                
          <!-- <mat-option value="Risk Validation">Risk Validation</mat-option> -->
          <mat-option value="In Progress">In Progress</mat-option>
          <mat-option value="Not Started">Not Started</mat-option>
      </mat-select>
  </mat-form-field> 
</td>    
<td>  
  <mat-form-field appearance="outline" style="width:150px">
      <mat-label>Choose a date</mat-label>
      <input matInput [matDatepicker]="myDatepicker" (dateInput)="FilterFormArray()" formControlName="Filter_DueDate">
      <mat-datepicker-toggle  [for]="myDatepicker"   matSuffix></mat-datepicker-toggle>
      <mat-datepicker  #myDatepicker ></mat-datepicker>
  </mat-form-field>     
</td>

</tr>
</table>      

<table  formArrayName="quantities">                                         
  <tr><h3 style="font-weight: 500;margin-left: 5px;">Vulnerability Details</h3></tr>
  <tr>
      <td>  
          <label style="font-weight: 600;margin-left: 30px;">Date Raised</label>
          <label style="font-weight: 600;margin-left: 165px;">Title</label>
          <label style="font-weight: 600;margin-left: 822px;">Status</label>
      </td>
  </tr>
  <tr *ngFor="let quantity of quantities().controls; let i=index" [formGroupName]="i">
    <td>
      <!-- Repeating Section Starts -->
      <mat-expansion-panel  style="width: 1355px;margin-left: 5px;" #matExpansionPanel
      
      (opened)="togglePanels(i)"  [expanded]="i==indexExpanded" (closed)="PanelClose()">
        <!-- (opened)="isExpanded = true" (closed)="isExpanded = false" (click)="togglePanels(i)" (opened)="togglePanels(i)" -->                
        <mat-expansion-panel-header>
            <mat-panel-title>                                          
            <!-- <mat-panel-description>
              {{i}}
            </mat-panel-description> -->
            <!-- <span *ngIf="isExpanded" style="float: right;height: fit-content;margin-top: 13px;"> <label  align="right">Filter</label></span>        -->
        <table> 
            <tr style="height:25px"></tr>        
            <!-- <tr *ngIf="isExpanded" align="right"> <td><label>Filter</label></td></tr>        -->
            
            <tr>                                                                
                <td>
                    
                    <mat-form-field appearance="outline" >
                        <mat-label></mat-label>
                        <input matInput [matDatepicker]="myDatepicker" [readonly] = "disableSelect" id="dateraised{{i}}"  name="DateRaised" class="form-control" formControlName="dateraised">
                        <mat-datepicker-toggle  [for]="myDatepicker" disabled=true  matSuffix></mat-datepicker-toggle>
                        <mat-datepicker  #myDatepicker></mat-datepicker>
                    </mat-form-field>
                    
                </td> 
                <td>                                      
                    <mat-form-field appearance="outline" style="width: 850px;">
                        <mat-label></mat-label>
                        <input matInput style="width: 1000px;"id="title{{i}}" [readonly] = "disableSelect" name="title"  class="form-control" formControlName="title" value="Codecov Software - Bash Uploader Exploitation"   >
                    </mat-form-field>
                </td>
                <td >                    
                    <mat-form-field appearance="outline">
                        <mat-label></mat-label>
                        <input matInput id="status{{i}}"  name="Status"  [readonly] = "disableSelect" class="form-control" formControlName="status">
                    </mat-form-field>
                </td>
            </tr>
            </table>
            <input type="hidden" id="flag{{i}}" class="form-control" name="flag" formControlName="flag">
        </mat-panel-title>
        <input type="hidden" id="VID{{i}}" class="form-control" formControlName="VID">
        <input type="hidden" id="LastUpdatedBy{{i}}" class="form-control" formControlName="LastUpdatedBy">
        <input type="hidden" id="notAnyContract{{i}}" class="form-control" formControlName="notAnyContract">
       
    </mat-expansion-panel-header>   
    <ng-container *ngTemplateOutlet="matExpansionPanelContent"></ng-container>
    <ng-template #matExpansionPanelContent>
            <table>                
                <tr> <td><label style="padding-right: 10px;font-weight: 600;">Description</label></td><tr>                
                <tr>                                                                                                            
                        <td>
                            <mat-form-field appearance="outline" style="width: 1310px;">
                                <mat-label></mat-label>
                            <textarea matInput rows="3" id="description{{i}}" [readonly] = "disableSelect" name="Desc" class="form-control" formControlName="description" >
                                </textarea>
                            </mat-form-field>
                    </td>
                </tr>
                <tr><td><label style="padding-right: 10px;font-weight: 600;">Corrective Action</label></td>  </tr>
                    <tr>                        
                    <td>                                         
                        <mat-form-field appearance="outline" style="width: 1310px;">
                            <mat-label></mat-label>
                            <textarea matInput rows="3" id="correctiveaction{{i}}" [readonly] = "disableSelect" name="CorrectiveAction"  class="form-control" formControlName="correctiveaction"  ></textarea>
                        </mat-form-field>
                    </td>
                </tr>
                </table>
                <table  formArrayName="UrlList" *ngIf="toShow">
                    <tr>
                      <label style="font-weight: bold;">URLs</label>     
                    </tr>
                    <tr *ngFor="let quantity of urlmethod(i).controls; let i=index" [formGroupName]="i">
                      <td>
                          <!-- <mat-form-field appearance="outline" style="width: 1335px;">
                            <mat-label>Textarea</mat-label> -->
                            <!-- <input matInput style="width: 750px;" id="iDesc" [(ngModel)]="objAssclass.Question" name="Desc"> -->
                            <!-- <textarea matInput rows="3" id="Desc{{i}}" class="form-control" formControlName="url"></textarea>
                        </mat-form-field> -->

                        <mat-form-field appearance="outline" style="width: 1000px;">
                          <input matInput type="url"  class='linkPtr' autocomplete="off" [readonly] = "disableSelect"
                                   formControlName="dataurl" style="color: blue;"  (click)="OpenPopUpPage(i)">
                                   <!-- (click)="OpenPopUpPage(objVulclass.CorrectiveAction)" class='linkPtr' href="#" id="urlData{{i}}" -->
                        </mat-form-field>
                        

                      </td>       
                      
                    </tr>
                  </table>
                  <label style="padding-left: 182px;">If none of your clients / contracts are utilising the impacted technology/version then please press the "Not used on any contract" button below.</label>  
                  <label style="padding-left: 166px; display: none;">Please confirm the senior client been formally informed about this vulnerability so they can take any appropriate action using the questionnaire below.</label>  
                  <br/><label style="width: 19%;"></label>
                  <button (click)="notanyContract(i)" id="noContract" style="width: 55%;background-color: cornflowerblue;border-radius: 12px;color: white;
                  text-align: center;margin: 4px 2px;">Not used on any contract </button>
                    
                
                
                <!-- Repeating Section 2 begins -->
                <label style="color: red;font-weight: 600; padding-top: 11px;">Please provide responses for the contracts below. To bulk update,complete the template and tick the checkbox for each applicable contract</label>

                <table  class="my_table client example col1-readonly col2-readonly col4-readonly LezzonPrize template row1-readonly" style="width: 1310px;"  formArrayName="contracts_array">                    
                    <tr align="center">
                        <td ><label style="width:70px;font-weight: 600;">Client</label></td> 
                        <td><label style="width:196px;font-weight: 600;">Contract/Contract Name</label></td> 
                        <td style="display:none"><label style="width:150px;font-weight: 600;">Contract Name</label></td> 
                        <td id="accManage" style="width:90px;font-weight: 600;"><label style="width:90px">Accenture manage the technology?</label></td> 
                        <td><label style="width:90px;font-weight: 600;">Accenture manage the impacted version?</label></td>    
                        <td><label style="width:90px;font-weight: 600;">CDP approved exception?</label></td>                            
                        <td><label style="width:100px;font-weight: 600;">Recommended patch or workaround installed?</label></td> 
                        <td><label style="width:120px;font-weight: 600;">Planned remediation date</label></td> 
                        <td style="width:90px;;font-weight: 600;"><label>Vulnerability Exploited?</label></td>  
                        <!-- <td class="client example col1-readonly col2-readonly col4-readonly LezzonPrize"><label style="width:90px;font-weight: 600;">Senior Client formally Informed?</label></td>  -->
                        
                        <td style="display:none"><label style="width:225px;font-weight: 600;">Comment/Action</label></td>                               
                        <td><label style="width:180px;font-weight: 600;">Please provide mitigation comments or additional information(unless fixed or not used and informed client etc)</label></td> 
                        <td><label style="width:16px;font-weight: 600;"></label></td>                                   
                    </tr> 
                    <!-- <table class="client example col1-readonly col2-readonly col4-readonly LezzonPrize" style="width: 1310px;"  formArrayName="contTemp_array"> -->
                        <!-- <tr *ngFor="let contTemp of contractsmethod(i).controls; let k=index" [formGroupName]="k">
                            
                                <td colspan="2" *ngIf="k<1"><label style="width:90px;font-weight: 600;">Template </label></td> 
                                <td align="center" *ngIf="k<1">                        
                                    <mat-form-field appearance="outline" style="width:90px">
                                        <mat-label>Select</mat-label>
                                        <mat-select id="tempDoAccManage{{i}}" name="tempDoAccManage" formControlName="tempDoAccManage">
                                            <mat-option value="Yes">Yes</mat-option>
                                            <mat-option value="No">No</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </td>  
                                <td align="center" *ngIf="k<1">                        
                                    <mat-form-field appearance="outline" style="width:90px;">
                                        <mat-label>Select</mat-label>
                                        <mat-select id="tempImpactedVersion{{i}}" name="tempImpactedVersion" formControlName="tempImpactedVersion">
                                            <mat-option value="Yes">Yes</mat-option>
                                            <mat-option value="No">No</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </td>  
                                <td align="center" *ngIf="k<1">                        
                                    <mat-form-field appearance="outline" style="width:90px">
                                        <mat-label>Select</mat-label>
                                        <mat-select id="tempClientAppExcep{{i}}" name="tempClientAppExcep" formControlName="tempClientAppExcep">
                                            <mat-option value="Yes">Yes</mat-option>
                                            <mat-option value="No">No</mat-option>
                                            <mat-option value="N/A">N/A</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </td>
                                <td align="center" *ngIf="k<1">                        
                                    <mat-form-field appearance="outline" style="width:95px;">
                                        <mat-label>Select</mat-label>
                                        <mat-select id="tempAppliedCorrAction{{i}}" formControlName="tempAppliedCorrAction" name="tempAppliedCorrAction">
                                            
                                            <mat-option value="No">No</mat-option>
                                            <mat-option value="Patch applied">Patch applied</mat-option>
                                            <mat-option value="Workaround applied">Workaround applied</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </td>  
                                <td align="center" *ngIf="k<1">                                                    
                                    <mat-form-field appearance="outline" style="width:150px">
                                        <mat-label>Choose a date</mat-label>
                                        <input matInput [matDatepicker]="picker"  id="tempRemediationDate{{i}}" formControlName="tempremediationraised">
                                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                        <mat-datepicker #picker></mat-datepicker>
                                      </mat-form-field>
                                </td> 
                                <td align="center" *ngIf="k<1" >                        
                                    <mat-form-field appearance="outline" style="width:90px" >
                                        <mat-label>Select</mat-label>
                                        <mat-select id="tempClientImp{{i}}" name="tempClientImp" formControlName="tempClientImp">
                                            <mat-option value="Yes">Yes</mat-option>
                                            <mat-option value="No">No</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </td>
                                <td align="center" *ngIf="k<1">                        
                                    <mat-form-field appearance="outline" style="width:90px">
                                        <mat-label>Select</mat-label>
                                        <mat-select  id="tempClientInf{{i}}" name="tempClientInf" formControlName="tempClientInf">
                                            <mat-option value="Yes">Yes</mat-option>
                                            <mat-option value="No">No</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </td> 
                                
                                <td align="center" *ngIf="k<1" style=display:none>
                                    <mat-form-field id="tempCommentActOuter{{i}}"appearance="outline" style="width: 275px;border-radius: 5px;height:150px">                            
                                        <textarea matInput rows="3" id="tempCommentAct{{i}}"  name="tempCommentAct" [readonly] = "disableSelect" style="height:120px; color: black;border-radius: 10px;padding-top: 5px;padding-bottom: 5px;text-align: center;white-space: normal;">
                                        </textarea>
                                    </mat-form-field>
                                </td>  
                                <td align="center" *ngIf="k<1">
                                    <mat-form-field id="tempMitigationCommentOuter{{i}}"appearance="outline" style="width: 275px;border-radius: 5px;height:50px">                            
                                        <textarea matInput maxlength="500" id="tempMitigationComment{{i}}" formControlName="tempMitigationComment" name="tempMitigationComment"  style="height:50px; color: black;border-radius: 10px;padding-top: 5px;padding-bottom: 5px;text-align: center;white-space: normal;overflow-x: hidden">
                                        </textarea>
                                    </mat-form-field>
                                </td>   
                            
                              
                        </tr> -->
                    <!-- </table> -->
                    
                    <tr *ngFor="let contract of contractsmethod(i).controls; let j=index" [formGroupName]="j" >   
                        
                        <td colspan="2" *ngIf="checkConTemp(i,j)" align="center"><label style="width:90px;font-weight: 600;background-color: lightgrey;
                            border-radius: 5px;height: 25px">Template </label></td> 

                        <td style="width:100px" align="center"  *ngIf="!checkConTemp(i,j)" [ngClass]="{'delClass': checkFlagDelegateVal(i,j)}">
                            <input matInput id="client" formControlName="client" [readonly]="disableSelect">
                        </td>
                        <td style="width:220px" align="center"  *ngIf="!checkConTemp(i,j)" [ngClass]="{'delClass': checkFlagDelegateVal(i,j)}">
                            <input matInput style="text-overflow: ellipsis" id="contract" formControlName="contract"
                                [readonly]="disableSelect">/
                            <input matInput style="text-overflow: ellipsis" id="contract_name" formControlName="contract_name"
                                [readonly]="disableSelect">
                        </td>
                    <!-- </td>
                    <td style="width:150px;white-space:nowrap" align="center"> -->
                <!-- <td style="width:150px;display:none;" align="center">
                <input matInput style="text-overflow: ellipsis"id="contract_name"   formControlName="contract_name" [readonly] = "disableSelect">
            </td> -->
            <td align="center" [ngClass]="{'delClass': checkFlagDelegateVal(i,j)}">                        
                <mat-form-field appearance="outline" [floatLabel]="'never'" style="width:90px;padding: 4px;" [ngClass]="{'byclass': appliedColor == 'grey'}">
                    <mat-label >Select</mat-label>
                    <mat-select id="DoAccManage{{i}}{{j}}" formControlName="DoAccManage" (selectionChange)="changecommaction($event.source.id,$event.value)"  name="DoAccManage">
                        <!-- .source.selected -->
                        <mat-option value="Yes">Yes</mat-option>
                        <mat-option value="No">No</mat-option>
                        <!-- <mat-option value="N/A">N/A</mat-option> -->
                    </mat-select>
                </mat-form-field>
            </td>  
            <td align="center" [ngClass]="{'delClass': checkFlagDelegateVal(i,j)}">                        
                <mat-form-field appearance="outline" [floatLabel]="'never'" style="width:90px;padding: 4px;" [ngClass]="{'byclass': appliedColor == 'grey'}">
                    <mat-label>Select</mat-label>
                    <mat-select id="ImpactedVersion{{i}}{{j}}" formControlName="ImpactedVersion" (selectionChange)="changecommaction($event.source.id,$event.value)" name="ImpactedVersion">
                        <mat-option value="Yes">Yes</mat-option>
                        <mat-option value="No">No</mat-option>
                        <!-- <mat-option value="N/A">N/A</mat-option> -->
                    </mat-select>
                </mat-form-field>
            </td>  
            <td align="center" [ngClass]="{'delClass': checkFlagDelegateVal(i,j)}">                        
                <mat-form-field appearance="outline" [floatLabel]="'never'" style="width:90px;padding: 4px;" [ngClass]="{'byclass': appliedColor == 'grey'}">
                    <mat-label>Select</mat-label>
                    <mat-select id="ClientAppExcep{{i}}{{j}}" formControlName="ClientAppExcep" (selectionChange)="changecommaction($event.source.id,$event.value)" name="ClientAppExcep">
                        <mat-option value="Yes">Yes</mat-option>
                        <mat-option value="No">No</mat-option>
                        <mat-option value="N/A">N/A</mat-option>
                    </mat-select>
                </mat-form-field>
            </td>
            <td align="center" [ngClass]="{'delClass': checkFlagDelegateVal(i,j)}">                        
                <mat-form-field appearance="outline" [floatLabel]="'never'" style="width:95px;padding: 4px;" [ngClass]="{'byclass': appliedColor == 'grey'}">
                    <mat-label>Select</mat-label>
                    <mat-select id="AppliedCorrAction{{i}}{{j}}" formControlName="AppliedCorrAction" (selectionChange)="changecommaction($event.source.id,$event.value)" name="AppliedCorrAction">
                        <!-- <mat-option value="Yes">Yes</mat-option> -->
                        <mat-option value="No">No</mat-option>
                        <mat-option value="Patch applied">Patch applied</mat-option>
                        <mat-option value="Workaround applied">Workaround applied</mat-option>
                        <!-- <mat-option value="N/A">N/A</mat-option> -->
                    </mat-select>
                </mat-form-field>
            </td>  
            <td align="center" [ngClass]="{'delClass': checkFlagDelegateVal(i,j)}">                                                    
                <mat-form-field appearance="outline" [floatLabel]="'never'" style="width:150px;padding: 4px;" [ngClass]="{'byclass': appliedColor == 'grey'}">
                    <mat-label>Choose a date</mat-label>
                    <input matInput [matDatepicker]="picker"  id="RemediationDate{{i}}{{j}}" formControlName="remediationraised" (dateChange)="dateChangeEvent($event)">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
            </td> 
            <td align="center" [ngClass]="{'delClass': checkFlagDelegateVal(i,j)}">                        
                <mat-form-field appearance="outline" [floatLabel]="'never'" style="width:90px;padding: 4px;" [ngClass]="{'byclass': appliedColor == 'grey'}">
                    <mat-label>Select</mat-label>
                    <mat-select id="ClientImp{{i}}{{j}}" formControlName="ClientImp"  name="ClientImp" (selectionChange)="changecommaction($event.source.id,$event.value)" name="ClientImp">
                        <mat-option value="Yes">Yes</mat-option>
                        <mat-option value="No">No</mat-option>
                        <!-- <mat-option value="N/A">N/A</mat-option> -->
                    </mat-select>
                </mat-form-field>
            </td>
            
            <td align="center" [ngClass]="{'delClass': checkFlagDelegateVal(i,j)}" style=display:none>                        
                <mat-form-field appearance="outline" [floatLabel]="'never'" style="width:90px;padding: 4px;">
                    <mat-label>Select</mat-label>
                    <mat-select  id="ClientInf{{i}}{{j}}" formControlName="ClientInf" (selectionChange)="changecommaction($event.source.id,$event.value)" name="ClientInf">
                        <mat-option value="Yes">Yes</mat-option>
                        <mat-option value="No">No</mat-option>
                        <!-- <mat-option value="N/A">N/A</mat-option> -->
                    </mat-select>
                </mat-form-field>
            </td> 
            
            <td align="center" style=display:none>
                <mat-form-field id="CommentActOuter{{i}}{{j}}"appearance="outline" style="width: 275px;border-radius: 5px;height:150px">                            
                    <textarea matInput rows="3" id="CommentAct{{i}}{{j}}"  name="CommentAct" [readonly] = "disableSelect" style="height:120px; color: black;border-radius: 10px;padding-top: 5px;padding-bottom: 5px;text-align: center;white-space: normal;">
                    </textarea>
                </mat-form-field>
            </td>  
            <td align="center" [ngClass]="{'delClass': checkFlagDelegateVal(i,j)}">
                <mat-form-field id="MitigationCommentOuter{{i}}{{j}}"appearance="outline" style="width: 250px;border-radius: 5px;height:50px;padding-left: 3px;
                padding-right: 3px;">                            
                    <textarea matInput maxlength="500" id="MitigationComment{{i}}{{j}}" formControlName="MitigationComment" name="MitigationComment"  style="height:50px; color: black;border-radius: 10px;padding-top: 5px;padding-bottom: 5px;text-align: center;white-space: normal;overflow-x: hidden">
                    </textarea>
                </mat-form-field>
            </td> 
            <td align="left" [ngClass]="{'delClass': checkFlagDelegateVal(i,j)}">
                <input type="checkbox" name="list_name" class="form-check-input" id="chkList{{i}}{{j}}" formControlName="chkList" name="chkList" [checked]="contract.TemplateCheckbox" (change)="onChecklistChange($event.target.checked, i,j)" />
            </td>    
            <td align="left" style="display: none;">
                <input type="checkbox" name="list_name" class="form-check-input" id="FlagDelegate{{i}}{{j}}" formControlName="FlagDelegate" name="FlagDelegate" />
            </td>         
                    </tr>                             
                </table>
<br />
<br />
<!-- Repeating Section 2 ends -->
<table style="width:800px;"  formArrayName="Delegate_array">  
    <!-- class="delegate del del1-readonly" -->
    <!-- margin-left: 830px; -->
    <tr >
        <td style="width:150px"><label style="font-weight: 600;">Contract/Contract Name</label></td> 
        <td style="width:150px"><label style="font-weight: 600;">Delegate</label></td>                          
    </tr>
    <tr *ngFor="let quantity of delegatemethod(i).controls; let j=index" [formGroupName]="j">
        <td style="width:200px">
            <mat-form-field style="width:378px" >
                <mat-label>Multi</mat-label>
                <mat-select id="contractnumber{{i}}{{j}}" formControlName="contractnumber" multiple [(value)]="selectDel[j]" >
                    <mat-option *ngFor="let lang of DDdata" [value]="lang.contract">{{lang.contract}}/{{lang.contract_name}}
                        <!-- <mat-checkbox [checked]="getSelectedDel(lang.contract)">
                        </mat-checkbox> -->
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </td>
        <td style="width:250px">
              
              <mat-form-field class="example-full-width" appearance="fill" >
                <mat-label></mat-label>
                <!-- (change)="valChangedforDel(choosedValue1.value,j,$event)" #choosedValue1 (optionSelected)="isOptionSelected($event,i,j)"-->
                <!-- [(value)]="selectDelName[j]" [value]=""-->
                <input type="text"
                       placeholder="Pick one"
                       aria-label=""
                       matInput
                       (keyup)="onSearchKeydown($event,i,j)"
                       formControlName="delegates" 
                       [formControl]="myControl"
                       [matAutocomplete]="auto" [(value)]="selectDelName[j]"
                       id="deleg{{i}}{{j}}" #choosedValue1
                       >    
                <mat-autocomplete #auto="matAutocomplete"  (optionSelected)="isOptionSelected($event,i,j)" [displayWith]="displayFn">
                  <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                    {{option}}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
                <img src="assets/People.png" style="width:25px;height:25px;margin-right: 14px;" />                            
                
        </td> 
        <td>
            <img src="assets/Minus Sign.svg" style="width:20px" id="AssessMinusbutton{{i}}" *ngIf="j >= 0" (click)="removeDelegate(i,j)"/>
        </td>
    </tr>
        <tr>
            <td style="width:30px">
                <img src="assets/Plus Sign.svg" style="width:20px" (click)="addDelegate(i)" />
            </td>
        </tr>      
</table>
<!-- <button  class="buttonnewvul" style="margin-bottom:30px;" id="{{i}}" [disabled]="disableDelButton(i)" (click)="onSubmit($event,true)">Delegate</button>  -->
<!-- margin-left: 1200px; -->
                <br/>
                <table style="display: none;">                
                    <tr> <td><label style="padding-right: 10px;font-weight: 600;">Delivery Team Comments</label></td>                        
                        <!-- <td style="padding-left: 50px;" ><label style="padding-right: 10px;">Delegate</label></td> -->
                    </tr>                
                                     
                        <tr>                        
                        <td>                                         
                            <mat-form-field appearance="outline" style="width: 1310px;">
                                <mat-label></mat-label>
                                <textarea matInput rows="3" id="delivery_team_comments{{i}}"  name="Delivery_Team_Comments" formControlName="deliveryteamcomment" ></textarea>
                            </mat-form-field>
                        </td>
                        <!-- <td style="padding-left: 50px;">
                            <mat-form-field appearance="outline">
                                <mat-label></mat-label>
                                <input matInput id="delegate"  name="Delegate"  >
                            </mat-form-field>
                        </td> -->
                    </tr>
                    </table>  
                    <div style="width: 1376px;text-align:center;">
                        
                        <button (click)="confirmDialog($event,false)" id="{{i}}" *ngIf="!Hidebtn" class="buttonnewvul">Save</button>
                        <button (click)="PanelClose()" id="{{i}}" *ngIf="!Hidebtn" class="buttonnewvul">Cancel</button>
                      <a  *ngFor="let lang of EmailData" href="mailto:{{lang.AddressTo}}?cc={{lang.AddressCC}}&subject={{lang.EmailSubject}}" style="text-decoration: none !important;line-height: 12px;margin-top: 0px;" class="btn buttonnewvul" >Request Help from GCC</a>                          
                        <button (click)="UnlockBlock($event)" id="{{i}}" *ngIf="Hidebtn" class="buttonnewvul">Unlock</button>
                        </div>                                                                                 

    </ng-template>
    </mat-expansion-panel>
    
      <!-- Repeating Section Ends -->            
    </td>         
    <!-- <td>                                    
        <img src="assets/Minus Sign.svg" style="width:20px" id="UserVulMinusbutton{{i}}" *ngIf="i > 0" (click)="removeQuantity(i)"/>
    </td> -->
  </tr>

  <!-- <tr>                                
    <img src="assets/Plus Sign.svg" style="width:20px" id="UserVulplusbutton" (click)="addQuantity()"/>
</tr> -->    
</table>              
</form>
<!-- <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator> -->
<ngx-spinner
bdColor="rgba(51,51,51,0.8)"
size="medium"
color="#fff"
type="ball-scale-multiple">
<p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>